export default "__VITE_ASSET__CLH0ysyY__"